/* Product ask/share access and user-triggered copy; native dialogs/forms stay intact. */
(() => {
  if (window.__olixeraProductTools) return;
  window.__olixeraProductTools = true;
  let pendingOpen = null;
  let activeDialog = null;
  let dialogNumber = 0;
  const triggerSelector = 'button[data-olixera-product-tool]';
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function syncShare(button) {
    if (!button?.dataset.content) return;
    const dialog = button.closest('[data-olixera-product-dialog]');
    const variant = document.getElementById(button.dataset.olixeraProductForm)?.querySelector('input[name="id"]')?.value;
    try {
      const url = new URL(button.dataset.content);
      const selectedVariant = variant || url.searchParams.get('variant');
      url.search = '';
      url.hash = '';
      if (/^\d+$/.test(selectedVariant || '')) url.searchParams.set('variant', selectedVariant);
      button.dataset.content = url.href;
      const label = dialog?.querySelector('.copy__url');
      if (label) label.textContent = url.href;
      dialog?.querySelectorAll('[data-share-url]').forEach(control => { control.dataset.shareUrl = url.href; });
    } catch { /* The Liquid-rendered URL remains the fallback. */ }
  }

  function visibleControls(modal) {
    return [...modal.querySelectorAll(focusableSelector)].filter(control =>
      !control.closest('[hidden], .hidden, [aria-hidden="true"]') && control.getClientRects().length
    );
  }

  function finishDialog() {
    if (!activeDialog) return;
    const { trigger, observer } = activeDialog;
    activeDialog = null;
    observer.disconnect();
    trigger.setAttribute('aria-expanded', 'false');
    if (trigger.isConnected) trigger.focus({ preventScroll: true });
  }

  function stopPending(request = pendingOpen) {
    if (!request) return;
    clearTimeout(request.timer);
    clearInterval(request.retry);
    request.observer.disconnect();
    if (pendingOpen === request) pendingOpen = null;
  }

  function connectPendingDialog() {
      const request = pendingOpen;
      if (!request) return;
      const { trigger, owner, previousModal } = request;
      if (!trigger.isConnected) { stopPending(request); return; }
      // Only this opener's newly created native modal can consume the request.
      const modal = owner.modal?.modal;
      if (!modal?.isConnected || modal === previousModal ||
          !modal.classList.contains('tingle-modal--visible') || modal.classList.contains('remove-loading') ||
          !modal.querySelector('[data-olixera-product-dialog]')) return;
      stopPending(request);
      if (activeDialog) {
        activeDialog.observer.disconnect();
        activeDialog.trigger.setAttribute('aria-expanded', 'false');
      }
      const heading = modal.querySelector('.title-popup');
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('tabindex', '-1');
      syncShare(modal.querySelector('[data-olixera-copy-link]'));
      if (heading) {
        if (!heading.id) heading.id = `OlixeraProductDialog-${++dialogNumber}`;
        modal.setAttribute('aria-labelledby', heading.id);
      }
      trigger.setAttribute('aria-expanded', 'true');
      const observer = new MutationObserver(() => {
        if (activeDialog?.modal === modal && (!modal.isConnected || modal.classList.contains('remove-loading'))) finishDialog();
      });
      // Tingle removes the node and does not reliably emit modal:closed.
      observer.observe(modal, { attributes: true, attributeFilter: ['class'] });
      observer.observe(document.body, { childList: true, subtree: true });
      activeDialog = { modal, trigger, observer };
      const first = modal.querySelector('[data-olixera-product-dialog] input:not([type="hidden"]), [data-olixera-copy-link]');
      (first || visibleControls(modal)[0] || modal).focus({ preventScroll: true });
  }

  document.addEventListener('click', event => {
    const shareDialog = event.target.closest?.('[data-olixera-product-dialog="share"]');
    if (shareDialog) syncShare(shareDialog.querySelector('[data-olixera-copy-link]'));
    const trigger = event.target.closest?.(triggerSelector);
    const owner = trigger?.closest('product-addons');
    if (!owner) return;
    stopPending();
    const request = { trigger, owner, previousModal: owner.modal?.modal };
    request.observer = new MutationObserver(connectPendingDialog);
    pendingOpen = request;
    request.observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    // Pointer events can checkpoint microtasks between capture and native target
    // listeners. Retain the exact opener until its modal arrives, with a bound.
    request.retry = setInterval(connectPendingDialog, 100);
    request.timer = setTimeout(() => stopPending(request), 4000);
  }, true);

  document.addEventListener('modal:opened', () => {
    connectPendingDialog();
    // Also cover implementations assigning owner.modal after their open callback.
    queueMicrotask(connectPendingDialog);
  });

  document.addEventListener('keydown', event => {
    const trigger = event.target.closest?.(triggerSelector);
    if (trigger === event.target && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      if (!event.repeat) trigger.click();
      return;
    }
    if (event.key !== 'Tab' || !activeDialog) return;
    const { modal } = activeDialog;
    const visibleDialogs = [...document.querySelectorAll('.tingle-modal--visible:not(.remove-loading)')];
    if (visibleDialogs.at(-1) !== modal) return;
    const controls = visibleControls(modal);
    if (!controls.length) {
      event.preventDefault();
      modal.focus();
      return;
    }
    const first = controls[0];
    const last = controls.at(-1);
    if (!modal.contains(document.activeElement) || (event.shiftKey && document.activeElement === first)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
    // Escape remains owned by the native Tingle handler.
  });

  document.addEventListener('click', async event => {
    const button = event.target.closest?.('button[data-olixera-copy-link]');
    if (!button || button.disabled) return;
    const status = button.closest('[data-olixera-product-dialog]')?.querySelector('[data-olixera-copy-status]');
    if (!status) return;
    status.textContent = '';
    button.disabled = true;
    button.classList.remove('copied');
    try {
      if (!navigator.clipboard?.writeText || !button.dataset.content) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(button.dataset.content);
      button.classList.add('copied');
      status.textContent = 'تم نسخ رابط العطر';
    } catch {
      status.textContent = 'تعذر نسخ الرابط تلقائيًا. يمكنك تحديد الرابط الظاهر ونسخه.';
    } finally {
      button.disabled = false;
    }
  });
})();
